import { DateTimeRangeValue } from './DateTimeRangeValue.model';

export interface Criteria {
  /**
   * The key for the criteria.
   */
  key: string;
  /**
   * The operator for the comparison.
   */
  operator: CriteriaOperatorEnum;
  /**
   * The value (for single valued comparison objects).
   */
  value?: unknown;
  /**
   * The start of the range (for comparison operators that take a range).
   */
  valueFrom?: unknown;
  /**
   * The end of the range (for comparison operators that take a range).
   */
  valueTo?: unknown;
  /**
   * The value for relative date range option.
   */
  dateTimeRangeValue?: DateTimeRangeValue;
}

export enum CriteriaOperatorEnum {
  Between = 'Between',
  Equal = 'Equal',
  NotEqual = 'NotEqual',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  Like = 'Like',
  UnLike = 'UnLike',
  StartsWith = 'StartsWith',
  EndsWith = 'EndsWith',
  IsSet = 'IsSet',
  NotSet = 'NotSet',
}
